import Vue from "vue";
import Vuetify from "vuetify";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    themes: {
        light: {
            primary: {
                lighten5: "#E3EAF5",
                lighten4: "#BACBE6",
                lighten3: "#8CA9D6",
                lighten2: "#5E86C5",
                lighten1: "#3C6CB8",
                base: "#164BA5",
                darken1: "#164BA5",
                darken2: "#12419B",
                darken3: "#0E3892",
                darken4: "#082882",
            },
            secondary: {
                lighten5: "#FCE4EC",
                lighten4: "#F8BCD0",
                lighten3: "#F48FB1",
                lighten2: "#F06292",
                lighten1: "#EC407A",
                base: "#E91E63",
                darken1: "#E61A5B",
                darken2: "#E31651",
                darken3: "#DF1247",
                darken4: "#D90A35",
            },
            accent: {
                lighten5: "#E5ECFF",
                lighten4: "#BFD0FF",
                lighten3: "#94B1FF",
                lighten2: "#6991FF",
                lighten1: "#497AFF",
                base: "#2962FF",
                darken1: "#245AFF",
                darken2: "#1F50FF",
                darken3: "#1946FF",
                darken4: "#0F34FF",
            },
            grey: {
                lighten5: "#F6F6F7",
                lighten4: "#E1E9EF",
                lighten3: "#D4DBE2",
                lighten2: "#AEBAC5",
                lighten1: "#9CA6AE",
                base: "#656D74",
                darken1: "#41464A",
                darken2: "#323639",
                darken3: "#242729",
                darken4: "#161719",
            },
            amber: {
                lighten1: "#f4c923",
            },
            success: "#4CAF50",
            warning: "#FFC107",
            error: "#FF5252",
            info: "#2196F3",
            anchor: "inherit",
        },
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            info: "#2D3539",
            content: "#EDF0F5",
            anchor: "#333",
        },
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function (theme) {
    return new Vuetify({
        lang: {
            locales: { ko: require("vuetify/lib/locale/ko") },
            current: "ko",
        },
        breakpoint: {
            mobileBreakpoint: "md",
            thresholds: {
                xs: 576,
                sm: 768,
                md: 1024,
                lg: 1200,
            },
            scrollBarWidth: 0,
        },
        theme: theme || basicTheme,
    });
}
